<template>
  <!--Start Footer Area-->
  <footer>
    <div class="bd-footer-area fix pt-170 theme-bg-6">
      <div class="bd-wave-wrapper">
        <div class="bd-wave"></div>
        <div class="bd-wave"></div>
      </div>
      <div class="theme-bg bd-footer-wrapper p-relative pt-60">
        <div class="container">
          <!-- footer area bg here  -->
          <div class="bd-footer-2 pb-15 pt-60 p-relative">
            <div class="bd-footer-shape d-none d-lg-block">

            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="bd-footer-widget-2 mb-50">
                  <div class="bd-footer-widget-content">
                    <h4 class="bd-footer-widget-title is-white mb-20">Quick links</h4>
                    <div class="bd-footer-list bd-footer-list-2">
                      <ul>
                        <li><router-link to="/about">About</router-link></li>
                        <li><router-link to="/campus">Campus</router-link></li>
                        <li><router-link to="/extracurricular">Activities</router-link></li>
                        <li><router-link to="/houses">House System</router-link></li>
                        <li><a href="https://bpr.eshala.co.in/jobs">Career</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="bd-footer-widget-2 mb-50">
                  <div class="bd-footer-widget-content">
                    <h4 class="bd-footer-widget-title is-white mb-20">Student Corner</h4>
                    <div class="bd-footer-list bd-footer-list-2">
                      <ul>
                        <li><router-link to="/admission">Admission Form</router-link></li>
                        <li><router-link to="/gallery">Gallery</router-link></li>
                        <li><router-link to="/contact">Contact</router-link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="bd-footer-widget-2 mb-50">
                  <div class="bd-footer-widget-content">
                    <h4 class="bd-footer-widget-title is-white mb-20">Programs</h4>
                    <div class="bd-footer-list bd-footer-list-2">
                      <!-- hero area side social  -->
                      <div class="bd-footer-social-wrapper is-white">
                        <div class="bd-footer-social">
                          <router-link to="/preprimary">Pre-Primary</router-link>
                        </div>
                        <div class="bd-footer-social">
                          <router-link to="/primary">Primary</router-link>
                        </div>
                        <div class="bd-footer-social">
                          <router-link to="/secondary">Secondary</router-link>
                        </div>
                        <div class="bd-footer-social">
                          <router-link to="/highersecondary">Senior Secondary</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="bd-footer-widget-2 mb-50">
                  <div class="bd-footer-widget-content">
                    <h4 class="bd-footer-widget-title is-white mb-20">Contact Us</h4>
                    <div class="bd-footer-contact is-white">
                      <ul>
                        <li><i class="fa-light fa-location-dot"></i><router-link to="/contact">Station Road, New Mandi, Bharatpur, Rajasthan</router-link></li>
                        <li><i class="fa-light fa-phone"></i><router-link to="/contact">9119275114</router-link>
                        </li>
                        <li><i class="fa-light fa-envelope"></i><a
                            href="mailto:bvschool@vedantafoundation.org" target="_blank">bvschool@vedantafoundation.org</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bd-footer-copyright pb-5 pt-25">
            <div class="bd-footer-copyright-wrap d-flex justify-content-center">
              <div class="bd-footer-copyright-text is-white pb-20">
                <p>Copyrighted by &copy;2025 <a href="/" rel="nofollow">Baburam Vedanta School</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- End Go Top Area -->
</template>

<script>
export default {
  name: "AppFooter",
};
</script>